// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'triangle';

export const Component = () => (
  <path d='M24.522 23.558 12.26 1 0 23.558h24.521ZM1.629 22.552 12.26 3.06l10.632 19.492H1.629Z' />
);

export const viewBox = '0 0 25 25';
